module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Bold-Alphabetic.9b366d1e.woff";